import states from '../graphql/countries_with_regions';
import {emails, users} from './mocks';

const divide_to = Math.floor(states.length/14);

const splitted = states.reduce((a,c,i,arr) => {
  return i % divide_to === 0
    ? [...a, [c]]
    : [...a, [...a[a.length - 1], c] ]
},[]);

const orgs_data = [
  {
    id: "0",
    name: 'Abe Residental'
  },
  {
    id: "1",
    name: 'Gili Residental'
  },
  {
    id: "2",
    name: 'Namuun Residental'
  },
  {
    id: "3",
    name: 'Abe Residental'
  },
  {
    id: "4",
    name: 'Gili Residental'
  },
  {
    id: "5",
    name: 'Namuun Residental'
  },
  {
    id: "6",
    name: 'Abe Residental'
  },
  {
    id: "7",
    name: 'Gili Residental'
  },
  {
    id: "8",
    name: 'Namuun Residental'
  },
  {
    id: "9",
    name: 'Abe Residental'
  },
  {
    id: "10",
    name: 'Gili Residental'
  },
  {
    id: "11",
    name: 'Namuun Residental'
  },
  {
    id: "12",
    name: 'Abe Residental'
  },
  {
    id: "13",
    name: 'Gili Residental'
  },
  {
    id: "14",
    name: 'Namuun Residental'
  }
];

const contactList = emails.map((email, idx) => ({
  name: `${users[idx]} - ${email}`
}))


export default {
  query: {
    authorizedSuborgs: async(root, { orgId, name }, index) => {
      const wait = () => new Promise(r => setTimeout(r,500));
      await wait();
      return splitted[+orgId].filter(o => new RegExp(`${name}`,"i").test(o.name))
        .map((o,i) =>({
          ...o,
          id: `user-suborgs-${orgId}-${i}`,
          marketerEmails: 'a@gmail.com, b@gmail.com',
          approvalRequired: Boolean(i % 2 === 0)
        }))
    },
    authorizedOrgs: (root, { name, first }, index) => {
      return first === 1
          ? [orgs_data[0]]
          : orgs_data.filter(o => new RegExp(`${name}`,"i").test(o.name))
    },
    accountsList: (root, { name, first }) => {
      return contactList
              .filter(o => new RegExp(`${name}`,"i").test(o.name))
              .slice(0, first)
              .map(({name},idx) => ({
                id: `accountsList-${name}-${idx}`,
                name
              }))
    }
  }
}
